var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{
        'deferred-img': true,
        'deferred-img--loading': _vm.isLoading,
    },attrs:{"alt":_vm.alt,"title":_vm.title,"src":_vm.fakeImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }